// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__tWt6L","info":"Panel_info__1ZefU","btns":"Panel_btns__9W29x","button":"Panel_button__DqVMY","input":"Panel_input__jcC7q"};